/* VOID — product-page extras (2026-10-20). Loaded with `defer`, only by the post-op
   product pages. Three small, independent behaviours, each a no-op when its markup
   isn't on the page:
     1. [data-ship]  delivery dates from the published promise (snippets/pdp-ship.liquid)
     2. [data-proc]  "Pick your procedure" tabs (snippets/nova-procedures.liquid)
     3. [data-calc]  "Do the math" calculator (snippets/pdp-calc.liquid)
   No dependencies, no network, nothing on the critical path. */
(function () {
  /* 1 · Delivery dates — ships within 24 hours (next business day), then a 3–6
     business-day transit. Weekends skipped; holidays not modelled (it's a range). */
  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }
  function fmt(d) {
    try { return new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).format(d); }
    catch (e) { return d.toDateString().slice(0, 10); }
  }
  document.querySelectorAll('[data-ship]').forEach(function (el) {
    var t = el.querySelector('[data-ship-text]');
    if (!t) return;
    var min = parseInt(el.getAttribute('data-ship-min'), 10) || 3;
    var max = parseInt(el.getAttribute('data-ship-max'), 10) || 6;
    var ship = addBusinessDays(new Date(), 1);
    var a = addBusinessDays(ship, min), b = addBusinessDays(ship, max);
    t.textContent = '';
    t.appendChild(document.createTextNode('Order today — arrives '));
    var s = document.createElement('strong');
    s.textContent = fmt(a) + ' – ' + fmt(b);
    t.appendChild(s);
    t.appendChild(document.createTextNode(' · free'));
    el.hidden = false;
  });

  /* 2 · Procedure tabs — WAI-ARIA tabs: click, arrow keys, Home/End. */
  document.querySelectorAll('[data-proc]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;
    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, to = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = (i + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = (i - 1 + n) % n;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = n - 1;
        if (to === null) return;
        e.preventDefault();
        select(to, true);
      });
    });
  });

  /* 3 · Do-the-math calculator. */
  document.querySelectorAll('[data-calc]').forEach(function (root) {
    var price = (parseInt(root.getAttribute('data-price'), 10) || 0) / 100;
    var range = root.querySelector('[data-calc-s]');
    var out = root.querySelector('[data-calc-s-out]');
    var radios = root.querySelectorAll('[data-calc-p]');
    var clinic = root.querySelector('[data-calc-clinic]');
    var sub = root.querySelector('[data-calc-sub]');
    var nEls = root.querySelectorAll('[data-calc-n]');
    if (!range || !price) return;
    function money(v) { return '$' + Math.round(v).toLocaleString('en-US'); }
    function run() {
      var n = parseInt(range.value, 10) || 12;
      var per = 150;
      radios.forEach(function (r) { if (r.checked) per = parseInt(r.value, 10) || per; });
      var min = parseInt(range.min, 10) || 0, max = parseInt(range.max, 10) || 100;
      range.style.setProperty('--fill', ((n - min) / (max - min) * 100) + '%');
      if (out) out.textContent = n;
      if (clinic) clinic.textContent = money(n * per);
      if (sub) sub.textContent = n + ' sessions × ' + money(per) + ' · on the clinic’s schedule';
      var be = Math.max(1, Math.ceil(price / per));
      nEls.forEach(function (e) { e.textContent = be; });
    }
    range.addEventListener('input', run);
    radios.forEach(function (r) { r.addEventListener('change', run); });
    run();
  });
})();
